export default "__VITE_ASSET__BuS6F8Rb__"